export type YoutubeVideoRef = {
  videoId: string;
  type: 'youtube';
};

const VIDEO_ID = /^[A-Za-z0-9_-]{11}$/;
const PATH_KINDS = new Set(['live', 'shorts', 'embed', 'v']);

function asYoutube(videoId: string | null | undefined): YoutubeVideoRef | null {
  if (!videoId || !VIDEO_ID.test(videoId)) return null;
  return { videoId, type: 'youtube' };
}

export function parseYoutubeUrl(
  url: string | null | undefined,
): YoutubeVideoRef | null {
  if (!url?.trim()) return null;
  let parsed: URL;
  try {
    parsed = new URL(url.trim());
  } catch {
    return null;
  }

  const host = parsed.hostname.replace(/^(www|m)\./, '');
  if (host === 'youtu.be') {
    const id = parsed.pathname.split('/').filter(Boolean)[0];
    return asYoutube(id);
  }
  if (
    host !== 'youtube.com' &&
    host !== 'music.youtube.com' &&
    host !== 'youtube-nocookie.com'
  ) {
    return null;
  }

  if (parsed.pathname === '/watch') return asYoutube(parsed.searchParams.get('v'));

  const parts = parsed.pathname.split('/').filter(Boolean);
  if (!PATH_KINDS.has(parts[0] ?? '')) return null;
  return asYoutube(parts[1]);
}

export function youtubeThumbnailUrl(videoId: string): string {
  return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
}

export function youtubeEmbedUrl(videoId: string): string {
  const params = new URLSearchParams({
    autoplay: '1',
    rel: '0',
    playsinline: '1',
  });
  return `https://www.youtube-nocookie.com/embed/${videoId}?${params}`;
}
